<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-datasubject" width="600px" :icon="'mdi mdi-plus'" :text="$t('datasubject.new')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <h2 v-if="parentEntity" v-html="$t('datasubject.owned-list', { name: $options.filters.translate(parentEntity.name) })"></h2>

    <nav class="breadcrumb" v-if="parentEntity">
      <a class="breadcrumb-item" href="/organization">
        {{ $t("organization.text") }}
      </a>

      <a class="breadcrumb-item" href="javascript:;">
        {{ parentEntity.name | translate }}
      </a>

      <a class="breadcrumb-item text-muted" href="javascript:;">
        {{ $t("datasubject.plural") }}
      </a>
    </nav>

    <table class="table project-list-table table-centered table-borderless compact ">
      <tr>
        <th scope="col" style="width:300px">
          <sortable-table-head field="name" :text="$t('datasubject.name')" tag="span" :request="request" />
        </th>
        <th scope="col" style="width:300px">{{ $t("datasubject-category.text") }}</th>

        <th scope="col" style="width: 15%">
          <a href="javascript:;" @click="toggleFilter">
            <span v-if="filterEnabled" class="text-warning">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-hide") }}
            </span>
            <span v-else class="text-muted">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-show") }}
            </span>
          </a>
        </th>
      </tr>

      <tr v-if="filterEnabled">
        <th><input class="form-control " v-model="nameFilter" /></th>

        <th>
          <filter-select
            id="categoryFilter"
            ref="categoryFilter"
            :placeholder="$t('datasubject-category.text')"
            :multiple="false"
            @filter="onCategorySearch"
            @changed="onCategorySelect"
          />
        </th>

        <th></th>
      </tr>
    </table>

    <div v-if="pagination" class="row">
      <div class="col-2 hider font-small" v-for="item in pagination.docs" :key="item._id">
        <div class="card text-center p-2" v-bind:class="{ 'bg-success': item.completed }">
          <div @click="routerPush(item)">
            <div class="mt-2 text-truncate hand">
              <h6 v-b-tooltip.hover :title="$options.filters.translate(item.name)">
                {{ item.datasubject.name | translate }}
              </h6>
              <span v-if="item.data" class="mb-0 text-muted">
                {{ item.data.name | translate }}
              </span>
              <span v-else class="text-light-gray" v-b-tooltip.hover :title="$t('datasubject.no-data')">
                {{ $t("datasubject.no-data") }}
              </span>
            </div>
          </div>
          <div v-if="hasUpdatePermission || hasRemovePermission" class="hidden">
            <div class="d-flex mt-3 team-social-links">
              <div v-if="hasUpdatePermission" class="flex-fill">
                <a @click="edit(item)" v-b-toggle="'sidebar-edit-organization-data'" v-b-tooltip.hover :title="$t('common.edit')">
                  <i class="bx bx-pencil text-primary"></i>
                </a>
              </div>

              <div v-if="hasRemovePermission" class="flex-fill">
                <a href="javascript:;void(0);" @click="deleteById(item)" v-b-tooltip.hover :title="$t('common.delete')">
                  <i class="bx bx-trash-alt text-danger"></i>
                </a>
              </div>
              <div class="flex-fill mt-1" v-b-tooltip.hover :title="$t('common.completed')">
                <b-form-checkbox switch size="sm" :checked="item.completed" @change="markAsComplete(item)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("datasubject.no-data") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import Form from "./organization-data-datasubject-form";

export default {
  components: { Form },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      categoryFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationDataDatasubject/selectedEntity"];
    },
    parentEntity() {
      return this.$store.getters["organizationDatasourceData/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationDataDatasubject/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDataDatasubject/isLoading"];
    },
    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
  },
  watch: {
    "$route.params.data": {
      immediate: true,
      handler() {
        this.fetchParent();
      },
    },

    request: {
      deep: true,
      handler() {
        this.paginate();
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  mounted() {},
  methods: {
    async fetchParent() {
      this.$store.commit("organizationDatasourceData/selectedEntity", undefined);
      this.$store.commit("organizationDataDatasubject/pagination", undefined);

      const parentId = this.$route.params.data;
      if (parentId) {
        await this.$store.dispatch("organizationDatasourceData/findById", parentId);
      }
      this.paginate();
    },
    async paginate() {
      const request = { ...this.request };
      if (this.parentEntity) {
        request.query = {
          ...request.query,
          data: { value: { _id: this.parentEntity._id }, isObject: true },
        };
      }

      await this.$store.dispatch("organizationDataDatasubject/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDataDatasubject/delete", item._id);
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    async markAsComplete(item) {
      try {
        await this.$store.dispatch("organizationDataDatasubject/markAsComplete", item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    edit(item) {
      this.$store.commit("organizationDataDatasubject/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject");
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDatasubjectCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onCategorySelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          category: { value: item._id, isObject: true },
        };
      } else {
        this.request.query["category"] = null;
        delete this.request.query["category"];
      }
    },
    routerPush(item) {
      this.$router.push("/datasubject-datasource/" + item._id);
    },
    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationDataDatasubject/resetForm");
    },
  },
};
</script>
